import { render, staticRenderFns } from "./listaProdutosLegada.vue?vue&type=template&id=e7dfbd6a&scoped=true"
import script from "./listaProdutosLegada.vue?vue&type=script&lang=js"
export * from "./listaProdutosLegada.vue?vue&type=script&lang=js"
import style0 from "./listaProdutosLegada.vue?vue&type=style&index=0&id=e7dfbd6a&prod&lang=css"
import style1 from "./listaProdutosLegada.vue?vue&type=style&index=1&id=e7dfbd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7dfbd6a",
  null
  
)

export default component.exports